<ion-header>
	<app-account-toolbar
		src="/assets/dean_and_david/burger-menu/impressum.svg"
		title="menu_popover.imprint"
		(back)="goBack()"
	></app-account-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<div
		*ngIf="checkIfVenueExistImpressum"
		class="dialog_info"
		[innerHtml]="checkIfVenueExistImpressum"
		role="region"
		aria-label="Venue Impressum Information"
	></div>

	<ng-container *ngIf="!checkIfVenueExistImpressum">
		<h1>Impressum</h1>
		<h2>Anbieter ohne den Bereich „Shop“</h2>
		<p>
			<strong>Gesetzliche Anbieterkennung:</strong><br />
			dean&david Franchise GmbH<br />
			vertreten durch die Geschäftsführerin Catrin Cichon<br />
			Lohenstraße 8<br />
			82166 Gräfelfing<br />
			Deutschland<br />
			Telefon: +49 89 26 20 59 410<br />
			E-Mail: <a href="mailto:info@deananddavid.com">info&#64;deananddavid.com</a><br />
			USt-IdNr.: DE254051922<br />
			eingetragen im Handelsregister des Amtsgerichtes München<br />
			Handelsregisternummer HRB 167009
		</p>
		<br />
		<p>
			<strong>Inhaltlich Verantwortlicher gemäß § 55 RStV:</strong><br />
			Herr David Baumgartner<br />
			Lohenstraße 8<br />
			82166 Gräfelfing<br />
			Deutschland
		</p>
		<br />

		<p>Wir sind nicht bereit, an Streitbeilegungsverfahren vor Verbraucherschlichtungsstellen teilzunehmen.</p>
		<br />

		<h2>Betreiber Onlineshop</h2>
		<br />

		<p>
			<strong>Gesetzliche Anbieterkennung:</strong><br />
			dean&david smart food GmbH<br />
			vertreten durch den Geschäftsführer David Baumgartner<br />
			Lohenstraße 8<br />
			82166 Gräfelfing<br />
			Deutschland<br />
			Telefon: +49 89 26 20 59 410<br />
			USt-IdNr.: DE297176705<br />
			eingetragen im Handelsregister des Amtsgerichtes München<br />
			Handelsregisternummer HRB 214849
		</p>
		<br />

		<h2>Alternative Streitbeilegung</h2>
		<br />

		<p>
			Die Europäische Kommission stellt eine Plattform für die außergerichtliche Online-Streitbeilegung (OS-Plattform) bereit,
			aufrufbar unter <a href="http://ec.europa.eu/odr" target="_blank" role="link">http://ec.europa.eu/odr</a>.
		</p>
		<br />

		<p>
			Wir sind seit 26.02.2018 Mitglied der Initiative „FairCommerce“.<br />
			Nähere Informationen hierzu finden Sie unter
			<a href="https://www.fair-commerce.de" target="_blank" role="link">www.fair-commerce.de</a>.
		</p>
		<br />

		<h2>Bildrechte</h2>
		<br />

		<p>
			Alle verwendeten Bilder sind zur zeitlich und örtlich unbegrenzten Nutzung der dean&david Franchise GmbH oder der dean&david
			Superfood GmbH überlassen.<br />
			Eine Vervielfältigung, Verbreitung oder öffentliche Wiedergabe ist ausschließlich im Falle einer widerruflichen und nicht
			übertragbaren Zustimmung der dean&david Franchise GmbH oder der dean&david Superfood GmbH gestattet.
		</p>
	</ng-container>
</ion-content>
